import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";

function Addresspage() {
    const [contact, setContact] = useState(null);
    const [loading, setLoading] = useState(true);
    const [authorized, setAuthorized] = useState(true);

    const loadData = async () => {
        try {
            setLoading(true);

            const person = JSON.parse(localStorage.getItem("person"));

            if (!person) {
                setAuthorized(false);
                setLoading(false);
                return;
            }

            let addressId = person.IdAddress;

            // Wenn keine AddressId vorhanden → suchen
            if (!addressId) {
                const searchResponse = await fetch(
                    `https://ej.puzzlepie.de/api.json/addresses/list?searchtext=${person.Name}`,
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: Cookies.get("token"),
                        },
                    }
                );

                if (searchResponse.status !== 200) {
                    setAuthorized(false);
                    setLoading(false);
                    return;
                }

                const searchResult = await searchResponse.json();

                if (!searchResult || searchResult.length === 0) {
                    setAuthorized(false);
                    setLoading(false);
                    return;
                }

                addressId = searchResult[0].IdAddress;
            }

            // Details laden
            const detailsResponse = await fetch(
                `https://ej.puzzlepie.de/api.json/Addresses/Details/?id=${addressId}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: Cookies.get("token"),
                    },
                }
            );

            if (detailsResponse.status !== 200) {
                setAuthorized(false);
                setLoading(false);
                return;
            }

            const details = await detailsResponse.json();

            if (!details) {
                setAuthorized(false);
            } else {
                setContact(details);
            }

        } catch (error) {
            console.error(error);
            setAuthorized(false);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadData();
    }, []);

    // ---------------- UI ----------------

    if (loading) {
        return (
            <div style={styles.center}>
                <div style={styles.card}>
                    <div style={styles.spinner}></div>
                    <h2>Lade Kontaktdaten...</h2>
                </div>
            </div>
        );
    }

    if (!authorized || !contact) {
        return (
            <div style={styles.center}>
                <div style={styles.cardError}>
                    <h2>🚫 Nicht autorisiert</h2>
                    <p>Du bist nicht berechtigt, diese Kontaktdaten zu sehen.</p>
                </div>
            </div>
        );
    }

    return (
        <div style={styles.center}>
            <div style={styles.card}>
                <h1 style={styles.title}>📇 Kontakt Information</h1>

                {contact.PrimaryContact && (
                    <p>
                        <strong>Name:</strong>{" "}
                        {contact.PrimaryContact.FirstName}{" "}
                        {contact.PrimaryContact.Surname}
                    </p>
                )}

                {contact.Company && (
                    <p>
                        <strong>Firma:</strong> {contact.Company}
                    </p>
                )}

                {contact.EMail && (
                    <p>
                        <strong>Email:</strong>{" "}
                        <a href={`mailto:${contact.EMail}`} style={styles.link}>
                            {contact.EMail}
                        </a>
                    </p>
                )}

                {contact.PhoneCompany && (
                    <p>
                        <strong>Telefon:</strong>{" "}
                        <a href={`tel:${contact.PhoneCompany}`} style={styles.link}>
                            {contact.PhoneCompany}
                        </a>
                    </p>
                )}
            </div>
        </div>
    );
}

// ---------------- Styles ----------------

const styles = {
    center: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        background: "#f4f6f8",
        fontFamily: "Arial, sans-serif",
    },
    card: {
        background: "white",
        padding: "30px",
        borderRadius: "12px",
        boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
        minWidth: "350px",
        textAlign: "center",
    },
    cardError: {
        background: "white",
        padding: "30px",
        borderRadius: "12px",
        boxShadow: "0 4px 15px rgba(255,0,0,0.2)",
        minWidth: "350px",
        textAlign: "center",
        border: "1px solid #ff4d4f",
    },
    title: {
        marginBottom: "20px",
    },
    link: {
        color: "#1890ff",
        textDecoration: "none",
    },
    spinner: {
        margin: "0 auto 20px auto",
        border: "4px solid #f3f3f3",
        borderTop: "4px solid #1890ff",
        borderRadius: "50%",
        width: "40px",
        height: "40px",
        animation: "spin 1s linear infinite",
    },
};

export default Addresspage;
